export default {
    ambassadorBtn_title: "Tirage au sort de cartes-cadeaux",
    ambassadorBtn_subtitle: "Reviews = Rewards",
    ambassadorPopup_title: "PARTICIPER À UN TIRAGE AU SORT DE CARTES-CADEAUX",
    ambassadorPopup_votes: '20 AirVotes',
    giveawayPopup_login: "Connectez-vous à Google ou Facebook",
    ambassadorPopup_review: "Laissez un commentaire sur l'une des pages de {v1}.",
    giveawayPopup_entered: "Vous serez inscrit au tirage au sort",
    ambassadorPopup_BtnLogin: "Commencez par vous connecter",
    giveawayPopup_BtnReview: "Laissez un commentaire sur l'une des pages de {v1}.",
    ambassadorPopup_cancel: "Je ne veux pas participer",
    ambassadorFinishTitle: "Nous apprécions votre avis honnête!\nVous avez été ajouté à notre tirage au sort.\nRevenez et votez à nouveau : chaque vote augmentera vos chances !",
    ambassadorMonthlyDrawing: "Every AirVote enters you into a monthly $100 drawing",
    ambassadorReceive: "Ambassadors will receive extra goodies and recognition!",
    ambassadorHelpUsTogether: "Help us succeed together!",
    giveawayPopup_proceedReview: "Procéder à l'envoi d'un avis",
    Thank_for_vote: "Merci pour votre vote. Vous voulez suivre vos votes ? Connectez-vous en utilisant",
    thankVoteTitle1: "Commentaires enregistrés",
    thankVoteTitle2_1: "Merci d'avoir voté",
    thankVoteTitle2_2: "Rejoignez AirVote pour pouvoir revoir et modifier vos votes",
    writeFeedBack: "Ajoutez une note (facultatif)",
    voteSuccessText_1: "Vote soumis, merci !",
    voteSuccessText_2: "Vous voulez le changer ? Appuyez sur un autre smiley.",
    voteSuccessText_3: "Vous avez quelque chose à dire ? Laissez une note facultative",
    feedbackTitle: "Ajoutez une note",
    feedbackTitleSoSo: "Qu'est-ce qui pourrait être mieux ?",
    feedbackTitleSad: "Qu'est-ce qui ne va pas ?",
    writeAReview: "Écrire un commentaire",
    writeAReviewTitle: "Vous pouvez écrire un commentaire pour {v1} ici :",
    yourNote: "Votre note",
    addYourNote: "Ajouter une note ?",
    commentPopupEmail: "Entrez votre email ou votre téléphone",
    feedbackText: "Je souhaite être contacté(e) à ce sujet",
    feedbackTextServiceLog: "Coordonnées des services",
    feedbackHelpText: "Le propriétaire du lieu le recevra pour prendre contact avec vous",
    feedbackTextRating: 'Pourquoi avez-vous donné cette note à cette enceinte?',
    title_404: "La page que vous essayez d'atteindre n'est pas disponible.",
    Submit: "Envoyez votre commentaire",
    Cancel: "Annuler",
    Logout: "Déconnexion",
    Sync_status: "Synchroniser le statut",
    reviewSocial: "A propos de nous",
    anonComment: "Ajouter un commentaire anonyme",
    powered_by: "Powered by AirVote\nGet it for your business",
    QR_smiley_disabled: "Ce QR Smiley® a été désactivé.\nVeuillez adresser vos commentaires directement à l'entreprise.",
    QR_smiley_disabled_links: "Des questions sur AirVote® ?\nConsultez le site {v1} ou envoyez-nous un courriel à {v2}.",
    QR_smiley_disabled_footer: "Merci de nous faire part de vos commentaires !",
    manageNotEnoughPermissions: "Vous n'avez pas assez de permissions pour gérer cette question AirVote. Veuillez vous connecter en utilisant un autre compte ou demander une autorisation.",
    welcomeAmbassador: "Welcome back, J Bar Ambassador!",
    ambassadorDescription: "Every AirVote enters you into a monthly $100 drawing (limit 1 per location per day)\n" +
        "Ambassadors will receive extra goodies and recognition!\n" +
        "\n" + "Help us succeed together!",
    Placement: "Placement",
    Update: "Mise à jour",
    NewPlacementSaved: "Nouvel emplacement enregistré avec succès",
    PleaseEnterCorrectPlacement: "Veuillez saisir l'emplacement correct",
    manageGPSAllowTitle: "Cela vous dérange de partager votre position?",
    manageGPSAllowText: "Connaître l'emplacement exact d'un problème nous aide à le résoudre plus rapidement. Nous ne suivrons pas votre position ni ne la partagerons avec quiconque en dehors de notre équipe de service",
    manageGPSAllowOKButton: "D'accord pour partager",
    manageGPSAllowCancelButton: 'Je préfère ne pas',
    level2_notp: "Pas de papier Q",
    level2_full: "Plein",
    level2_dirty: "Sale",
    level2_smells: "Mauvaise odeurs",
    level2_broken: "Quelche chose de cassé",
    level2_otherl: "Autres",
    level2_nopaper: "Pas de serviettes",
    need_audio_permission_error: "Veuillez nous donner accès à votre microphone pour enregistrer des sons",
    level2_title: "Services rendus",
    level2_maxCount: "Nombre maximum d'articles à choisir: {v1}",
    vote_screen_public_review_popup_title: "Laissez-nous un avis public",
    sl_final_Title1: "Service log saved!",
    serviceLogInfoBtn: "Historique d'entretien",
    snapPicturePopupTitle: "Confirmez votre vote avec la photo des toilettes",
    snapPictureButton: "Prenez une photo",
    snapPicturePopupContinue: "Continue",
    subtitleDefault: "Votre image du problème est appréciée!",
    signIn_Pin: "Sign in with PIN",
}
